import React from 'react';
import { heroData, logoUrl } from '../data/mock';
import { ChevronDown } from 'lucide-react';

const Hero = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToAbout = (e) => {
    e.preventDefault();
    const element = document.querySelector('#about');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden">

      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.backgroundImage}
          alt="Elite Marriage Lawns"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-black/50 to-transparent z-10" />
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-black/50 to-transparent z-10" />

      {/* Content */}
      <div className="relative z-20 text-center px-6 max-w-4xl mx-auto">
        {/* Logo in Hero */}
        <div className="mb-8 animate-fade-in">
          <img
            src={logoUrl}
            alt="Elite Marriage Lawns Logo"
            className="h-32 md:h-40 w-auto mx-auto drop-shadow-2xl" />

        </div>

        {/* Headline */}
        <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight animate-fade-in-up opacity-0" style={{ animationDelay: '0.2s', animationFillMode: 'forwards' }}>
          {heroData.headline}
        </h1>

        {/* Decorative Line */}
        <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-[#C9A962] to-transparent mx-auto mb-6 animate-fade-in-up opacity-0" style={{ animationDelay: '0.4s', animationFillMode: 'forwards' }} />

        {/* Subheadline */}
        <p className="font-sans text-lg md:text-xl text-white/90 mb-10 tracking-wide animate-fade-in-up opacity-0" style={{ animationDelay: '0.5s', animationFillMode: 'forwards' }}>
          {heroData.subheadline}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up opacity-0" style={{ animationDelay: '0.7s', animationFillMode: 'forwards' }}>
          <button
            onClick={scrollToContact}
            className="btn-primary text-sm md:text-base">

            {heroData.ctaText}
          </button>
          <button
            onClick={scrollToAbout}
            className="btn-secondary border-white text-white hover:bg-white hover:text-[#2C2C2C] text-sm md:text-base">

            Explore Venue
          </button>
        </div>

        {/* Trust Badges */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-white/70 text-sm animate-fade-in opacity-0" style={{ animationDelay: '1s', animationFillMode: 'forwards' }}>
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#C9A962]" />
            Best Wedding Lawn in Allaganj
          </span>
          <span className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#C9A962]" />
            1500+ Happy Celebrations
          </span>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToAbout}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 text-white/80 hover:text-[#C9A962] transition-colors cursor-pointer animate-bounce"
        aria-label="Scroll down">

        <ChevronDown size={36} />
      </button>
    </section>);

};

export default Hero;